export default "__VITE_ASSET__BYQVPTaC__"